import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import AppRoutes from './routes/AppRoutes';
import './App.css';

function App() {
  return (
    <Provider store={ store }>
      <Router>
        <AppRoutes />
      </Router>
    </Provider>
  );
}

export default App;
